import { render, staticRenderFns } from "./SendToForm.vue?vue&type=template&id=5c82932a"
import script from "./SendToForm.vue?vue&type=script&lang=js"
export * from "./SendToForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports